import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    instructional_methods: [],
    instructional_methods_url: '/teaching/instructional-method'
}

const getters = {
    [names.INSTRUCTIONAL_METHODS]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_methods
            .filter((x) => x.school == get.store.state.user.school)
            .sort((a, b) => a.id - b.id);
    },
    [names.INSTRUCTIONAL_METHOD]: (state,) => id => {
        return state.instructional_methods.find(x => x.id == id);
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_METHODS]: (state, instructional_methods) => {
        instructional_methods.forEach(element => {
            let index = state.instructional_methods.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_methods.splice(index, 1, element);
            else state.instructional_methods.push(element);
        });
    },
    [names.MUTATE_INSTRUCTIONAL_METHOD]: (state, instructional_method) => {
        let index = state.instructional_methods.findIndex(x => x.id == instructional_method.id);
        if (index != -1) state.instructional_methods.splice(index, 1, instructional_method);
        else state.instructional_methods.push(instructional_method);
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_METHOD]: (state, instructional_method_id) => {
        let index = state.instructional_methods.findIndex(x => x.id == instructional_method_id);
        if (index != -1) state.instructional_methods.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_INSTRUCTIONAL_METHODS]: ({
        commit,
        state,
    }, force) => {
        return new Promise((resolve, reject) => {
            if (!force && state.instructional_methods.length > 0) {
                resolve(state.instructional_methods);
                return;
            }
            restful.GetAll(`${state.instructional_methods_url}/`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_METHODS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_METHOD]: ({
        commit,
        state
    }, instructional_method) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_methods_url}/`, instructional_method)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_METHOD, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_METHOD]: ({
        commit,
        state
    }, instructional_method) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_methods_url}/${instructional_method.id}/`, instructional_method)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_METHOD, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_method_id, item }
    [names.PATCH_INSTRUCTIONAL_METHOD]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_methods_url}/${payload.instructional_method_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_METHOD, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_METHOD]: ({
        commit,
        state
    }, instructional_method_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_methods_url}/${instructional_method_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_METHOD, instructional_method_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
